import { BUSINESS, WA_DEFAULT_MSG } from "@/constants/business";

const WaIcon = ({ className = "w-7 h-7" }) => (
  <svg
    viewBox="0 0 32 32"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden="true"
  >
    <path d="M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39a.63.63 0 0 1-.315-.1c-.802-.402-1.504-.817-2.163-1.447-.545-.516-1.146-1.29-1.46-1.963a.426.426 0 0 1-.073-.215c0-.33.99-.945.99-1.49 0-.143-.73-2.09-.832-2.335-.143-.372-.214-.487-.6-.487-.187 0-.36-.043-.53-.043-.302 0-.53.115-.746.315-.688.645-1.032 1.318-1.06 2.264v.114c-.015.99.472 1.977 1.017 2.78 1.23 1.82 2.506 3.41 4.554 4.34.616.287 2.035.788 2.722.788.817 0 2.15-.515 2.45-1.318.158-.43.158-.802.115-.93-.072-.214-.387-.33-.616-.45-.703-.348-1.575-.83-1.875-.83zM16 7.105a8.95 8.95 0 0 0-7.6 13.62L7.2 25l4.4-1.16A8.95 8.95 0 1 0 16 7.105zm0 16.07a7.106 7.106 0 0 1-3.62-1l-.26-.155-2.685.715.72-2.625-.17-.27a7.13 7.13 0 1 1 6.025 3.335zM26.45 5.55A14.665 14.665 0 0 0 16 1.25C7.872 1.25 1.25 7.872 1.25 16c0 2.595.685 5.12 1.98 7.34l-2.105 7.7 7.875-2.075a14.74 14.74 0 0 0 7 1.78h.005C24.13 30.745 30.75 24.124 30.75 16a14.67 14.67 0 0 0-4.3-10.45z" />
  </svg>
);

const PhoneIcon = ({ className = "w-4 h-4" }) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden="true">
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.36 1.9.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.91.34 1.85.57 2.81.7A2 2 0 0 1 22 16.92z" />
  </svg>
);

export default function WhatsAppFloating() {
  return (
    <div
      data-testid="whatsapp-floating-container"
      className="fixed right-4 sm:right-6 z-[60] flex flex-col items-end gap-3"
      style={{ bottom: "72px" }}
    >
      {BUSINESS.phones.map((p, idx) => (
        <a
          key={p.whatsapp}
          data-testid={`whatsapp-float-btn-${idx + 1}`}
          href={`https://wa.me/${p.whatsapp}?text=${encodeURIComponent(WA_DEFAULT_MSG)}`}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={`WhatsApp ile ${p.display} numarasına yaz`}
          className="group flex items-center gap-2 rounded-full bg-[#25D366] text-white shadow-2xl hover:bg-[#1ebe57] transition-all duration-300 wa-pulse"
        >
          <span className="flex items-center justify-center w-14 h-14 rounded-full bg-[#25D366] group-hover:scale-105 transition-transform">
            <WaIcon className="w-7 h-7" />
          </span>
          <span className="hidden sm:flex flex-col pr-5 pl-1 leading-tight">
            <span className="text-[10px] uppercase tracking-widest font-semibold opacity-90 flex items-center gap-1">
              <PhoneIcon className="w-3 h-3" /> {p.label}
            </span>
            <span className="text-sm font-bold">{p.display}</span>
          </span>
        </a>
      ))}
    </div>
  );
}
